// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Cege","image":"Header_image__2NCTs","name":"Header_name__3jWXT","info":"Header_info__27NKG","infoRow":"Header_infoRow__2sFtk"};